import { DonationFrequency } from '@web/graphql-components'
import { ProfileDataQuery } from '@web/graphql-queries/graphql'
import type { CampaignMatchedGivingSetting, Page as PageLayout } from '@web/graphql-types'
import { Nullable } from 'apps/fe-donation/utils'
import { create } from 'zustand'

type ElementSettingItem = {
  pageIds: Nullable<string>[]
}

export type ProgressBarElementSettingItem = ElementSettingItem & {
  goals: number[]
}

type PageStore = {
  amount: number
  charityId: string
  campaignId: string
  pageId: Nullable<string>
  pageBucketId: Nullable<string>
  profileId: Nullable<string>
  actions: PageActions
  isLiveMode: boolean
  isFirstLoad: boolean
  thankYouPageLayout?: PageLayout
  isThankYouPage: boolean
  isFbPixelLoaded: boolean
  purchaseEventId: string
  currentUrl?: string
  donationFrequency?: DonationFrequency
  elementSettings?: Record<string, ElementSettingItem | ProgressBarElementSettingItem>
  profileData?: Nullable<ProfileDataQuery['profileData']>
  isLoggedIn?: boolean
  isLoggedInProfile?: boolean
  campaignDomain?: Nullable<string>
  activeMatchedGiving?: CampaignMatchedGivingSetting & { activeRound: number }
  customFieldValues: Record<string, string>
  isPeerToPeerGivingNotificationEnabled?: Nullable<boolean>
  isEmbed?: boolean
  virtualGift?: any
}

type PageActions = {
  setAmount: (amount: number) => void
  setHasLoggedIn: (hasLoggedIn: boolean) => void
  getHasLoggedIn: () => boolean
  setCustomFieldValues: (customFieldValues) => void
}

const HAS_LOGGED_IN_KEY = 'hasLoggedIn'

export const usePageStore = create<PageStore>((set) => ({
  amount: 0,
  charityId: '',
  campaignId: '',
  pageId: '',
  pageBucketId: null,
  profileId: null,
  components: new Map(),
  isLiveMode: true,
  isFirstLoad: true,
  isThankYouPage: false,
  isFbPixelLoaded: false,
  purchaseEventId: '',
  customFieldValues: {},
  isEmbed: false,
  actions: {
    setAmount(amount) {
      set({ amount })
    },
    setHasLoggedIn(hasLoggedIn) {
      if (!hasLoggedIn) {
        window.localStorage.removeItem(HAS_LOGGED_IN_KEY)
        return
      }

      window.localStorage.setItem(HAS_LOGGED_IN_KEY, 'true')
    },
    getHasLoggedIn() {
      if (!window) {
        return false
      }

      return window.localStorage.getItem(HAS_LOGGED_IN_KEY) === 'true'
    },
    setCustomFieldValues(customFieldValues) {
      set((state) => ({ customFieldValues: { ...state.customFieldValues, ...customFieldValues } }))
    },
  },
}))
